import { Component, OnDestroy, OnInit } from '@angular/core';
import navigationLinks from '../../ui-components/navigation/links/links-builder';
import { DateTimeService } from '../../services/date-time.service';
import { UserService } from '../../users/user.service';
import { ILink } from '../../ui-components/navigation/links/link.interface';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {
  navigationLinks!: ILink[];
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(private datetimeService: DateTimeService,
    protected userService: UserService,
    private responsive: BreakpointObserver) { }

  ngOnInit(): void {
    this.navigationLinks = navigationLinks.build(this.userService);

    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  get copyrightYear() {
    return this.datetimeService.getCurrentTime().format('YYYY');
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  isExternalLink(link: ILink) {
    return link.isExternalLink;
  }

  shouldForceReload(link: ILink) {
    return link.forceReload;
  }

}
